import React from 'react';

import Text from '../Text';

import RemoveIcon from '../../../icons/close.svg';

import styles from './FileItem.scss';

type Props = {
  fileName: string;
  onRemove: () => void;
};

function FileItem(props: Props) {
  const { fileName, onRemove } = props;

  return (
    <div className={styles.fileItem} data-testid="file-item">
      <Text className={styles.fileName} small>
        {fileName}
      </Text>
      <button className={styles.closeButton} onClick={onRemove} aria-label="Remove file">
        <RemoveIcon className={styles.closeIcon} />
      </button>
    </div>
  );
}

export default React.memo(FileItem);
